var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.Utilities = OCS.Classes.Utilities || {};
OCS.Functions = OCS.Functions || {};
// Requires OCS.Interfaces.Utilities.base, OCS.Interfaces.Utilities.object
OCS.Functions.define_array_utilities = function () {
    return new Class({
        Implements: [new Class(OCS.Interfaces.Utilities.base), new Class(OCS.Interfaces.Utilities.object), new Class(OCS.Interfaces.Utilities.array)]
    });
};
OCS.Classes.Utilities.array = OCS.Functions.define_array_utilities();